import { createContext } from 'react';
// import Plausible from 'plausible-tracker';

import { TrackingEvent, TrackerHandles } from './Tracking.events';

export const LOCATION_CHANNEL_KEY = 'location';

export const TrackingContext = createContext<ContextProps>({
	gtag: null,
	gtm: null,
	metaPixel: null,
	tiktokPixel: null,
	segment: null,
	locationChannel: new BroadcastChannel(LOCATION_CHANNEL_KEY),
	matomo: null,
	sendEvent: () => {},
});

interface ContextProps extends TrackerHandles {
	location?: Location;
	locationChannel: BroadcastChannel;
	sendEvent: (event: TrackingEvent) => void;
}
